.camera {
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.cameraCanvas,
.cameraCanvasSelfie,
.cameraCanvasSelfieDesk {
  z-index: 5;
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
}

.cameraVideo,
.cameraVideoSelfie,
.cameraVideoSelfieDesk {
  z-index: 2;
  max-width: 100%;
  max-height: 100%;
  border-radius: 10px;
  transform: scale(-1, 1);
  -webkit-transform: scale(-1, 1);
  height: 60vh;
}

img {
  max-width: 100%;
  margin-top: 20px;
  border: 1px solid #ddd;
}

.video-overlay-canvas {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 7;
  pointer-events: none;
}

.face-guide-white,
.face-guide-yellow,
.face-guide-green {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  width: 60%;
  padding-bottom: calc(70% * 1.5);
  border: 3px dashed rgba(255, 255, 255, 0.7);
  border-radius: 50%;
  z-index: 5;
  pointer-events: none;
  box-sizing: border-box;
}

.face-guide-yellow {
  border: 3px dashed rgba(250, 253, 38, 0.7);
}

.face-guide-green {
  border: 3px dashed rgba(0, 255, 0, 0.7);
}

.countdown-overlay-style {
  position: absolute;
  inset: 0;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 6;
}

.capture-flash-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: white;
  opacity: 0;
  animation: capture-flash 0.2s ease-out;
  pointer-events: none;
  z-index: 10;
}

@keyframes bounce {
  0%,
  100% {
    transform: translateY(-25%);
    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);
  }
  50% {
    transform: none;
    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);
  }
}

.animate-bounce {
  animation: bounce 1s infinite;
}

@keyframes capture-flash {
  0% {
    opacity: 0;
  }
  50% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}

.countdown-text-style {
  color: white; /* text-white */
  font-size: 8rem; /* text-9xl (approx 128px) */
  font-weight: bold; /* font-bold */
  animation: bounce 1s infinite; /* animate-bounce */
}
